import React, { useState, useEffect } from 'react';

import {
  Container,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  makeStyles
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import DailyCashClosureDatatable from 'src/daily-cash-closure/ui/components/DailyCashClosureDatatable';

//import downloadDepositReceiptPdfById from 'src/daily-cash-closure/use-cases/downloadDepositReceiptPdfById';
//import downloadDepositNotePdfById from 'src/daily-cash-closure/use-cases/downloadDepositNotePdfById';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const DailyCashClosureListView = () => {
  const classes = useStyles();

  /*
    const [
        showSelectDownloadCreditNoteType,
        setShowSelectDownloadCreditNoteType
    ] = useState(false);

    const [
        selectedDownloadCreditNoteId,
        setSelectedDownloadCreditNoteId
    ] = useState(null);

    const handleDownload = (id, row) => {
        switch (row.PaymentType.code) {
            case 'CREDIT_NOTE':
                setSelectedDownloadCreditNoteId(id);
                setShowSelectDownloadCreditNoteType(true);
                break;
            default:
                setShowSelectDownloadCreditNoteType(false);
                downloadPaymentReceiptPdfById(id);
        }
    };

    const handleDownloadCreditNoteByType = type => {
        downloadCreditNotePdfById(selectedDownloadCreditNoteId, type);
        setShowSelectDownloadCreditNoteType(false);
    };

    const handleDialogCloseDownloadCreditNote = async id => {
        setShowSelectDownloadCreditNoteType(false);
    };



    <Dialog
                onClose={handleDialogCloseDownloadCreditNote}
                aria-labelledby="simple-dialog-title"
                open={showSelectDownloadCreditNoteType}
            >
                <DialogTitle id="simple-dialog-title">
                    Seleccione el tipo de nota de crédito
                </DialogTitle>
                <List>
                    <ListItem
                        button
                        onClick={() =>
                            handleDownloadCreditNoteByType(
                                'ORIGINAL_AND_DUPLICATE'
                            )
                        }
                        key={'ORIGINAL_AND_DUPLICATE'}
                    >
                        <ListItemText primary={'Original'} />
                    </ListItem>
                    <ListItem
                        button
                        onClick={() =>
                            handleDownloadCreditNoteByType('CUSTOMER')
                        }
                        key={'CUSTOMER'}
                    >
                        <ListItemText primary={'Digital'} />
                    </ListItem>
                </List>
            </Dialog>
    */

  return (
    <Page className={classes.root} title="Tesorería">
      <Container maxWidth={false}>
        <DailyCashClosureDatatable showAddButton={false} />
      </Container>
    </Page>
  );
};

export default DailyCashClosureListView;
